import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../../components/ErpTemplate';
import { FaSave } from 'react-icons/fa';
import api from '../../../../services/api';
import { useHistory } from 'react-router-dom';
import ReactSelect from '../../../../components/ReactSelect';
import { toast } from 'react-toastify';
import { FinField, FinInput } from '../../../../components/FinField';
import '../../../../css/financeiro-parcela-pagar.css';

const OPCOES_SIM_NAO = [
    { value: 'nao', label: 'Não' },
    { value: 'sim', label: 'Sim' },
];

const OPCOES_SITUACAO = [
    { value: 'ativo', label: 'Ativo' },
    { value: 'inativo', label: 'Inativo' },
];

const OPCOES_GRUPO = [
    { value: 'confirmados', label: 'Confirmados' },
    { value: 'pendentes', label: 'Pendentes' },
    { value: 'declinaram', label: 'Declinaram' },
    { value: 'semAereo', label: 'Confirmados Sem Aéreo' },
    { value: 'aereoEmissao', label: 'Confirmados Aéreo em Emissão' },
    { value: 'aereoEmitido', label: 'Confirmados Aéreo Emitido' },
    { value: 'standby', label: 'Standby' },
];

export default function CadastroEventoParticipanteSituacao({ match }) {
    const id = match.params.id;
    const empresa = localStorage.getItem("empresa");
    const token = localStorage.getItem('token');
    const [dados, setDados] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const history = useHistory();

    const buscar = () => {
        if (id) {
            api({
                method: "get",
                action: '/eventoParticipanteSituacao/' + id,
                token: token,
            }).then(response => {
                var dadosRecebidos = response.data.data;

                //transforma dados no formato aceito pelo reactselect
                if (dadosRecebidos.grupo?.constructor !== Array)
                    dadosRecebidos.grupo = [];
                dadosRecebidos.grupo = dadosRecebidos.grupo.map(function (objeto) {
                    return {
                        value: objeto.id,
                        label: objeto.nome
                    };
                });

                setDados(dadosRecebidos);
            }).catch(err => {
                //console.log(err)
            });
        }
    };

    const salvar = () => {


        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);
if (dados.grupo && Array.isArray(dados.grupo)) {
            dados.grupo = dados.grupo.map(item => item.value).join(',');
        }

        if (id) {//update
            api({
                method: 'put',
                action: '/eventoParticipanteSituacao/' + id,
                token: token,
                data: dados
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push("/eventoParticipanteSituacao");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        } else {//insert
            api({
                method: 'post',
                action: '/eventoParticipanteSituacao',
                token: token,
                data: { ...dados, ...{ empresa: empresa } }
            })
                .then(function (response) {
                    toast.success("Dados salvos com sucesso!");
                    history.push("/eventoParticipanteSituacao");
                })
                .catch(function (error) {
                    toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
                })
                .finally(() => {
                    setIsSubmitting(false);
                });
        }
    };

    useEffect(() => { //onload
        document.querySelector("#nome").focus(); //autofocus no nome
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Status de Participante</h1>
                    </div>
                </div>

                <form onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__card" style={{ padding: 16, marginBottom: 16 }}>
                        <div className="fin-pp__filters">
                            <FinField label="Situação">
                                <ReactSelect
                                    value={{ value: dados.situacaoRegistro, label: dados.nomeSituacaoRegistro }}
                                    onChange={e => setDados({ ...dados, ...{ "situacaoRegistro": e.value, "nomeSituacaoRegistro": e.label } })}
                                    options={OPCOES_SITUACAO}
                                />
                            </FinField>
                            <FinField label="Código">
                                <FinInput
                                    id="codigo"
                                    type="text"
                                    placeholder="Código"
                                    value={dados.codigo}
                                    onChange={e => setDados({ ...dados, ...{ "codigo": e.target.value } })}
                                />
                            </FinField>
                            <FinField label="Pedir data e hora?">
                                <ReactSelect
                                    value={{ value: dados.pedirdata, label: dados.nomePedirdata }}
                                    onChange={e => setDados({ ...dados, ...{ "pedirdata": e.value, "nomepedirdata": e.label } })}
                                    options={OPCOES_SIM_NAO}
                                />
                            </FinField>
                            <FinField label="Permitir enviar Carta?">
                                <ReactSelect
                                    value={{ value: dados.enviarcarta, label: dados.nomeEnviarcarta }}
                                    onChange={e => setDados({ ...dados, ...{ "enviarcarta": e.value, "nomeEnviarcarta": e.label } })}
                                    options={OPCOES_SIM_NAO}
                                />
                            </FinField>
                            <FinField label="Somente se tiver aéreo?">
                                <ReactSelect
                                    value={{ value: dados.seaereo, label: dados.nomeSeaereo }}
                                    onChange={e => setDados({ ...dados, ...{ "seaereo": e.value, "nomeSeaereo": e.label } })}
                                    options={OPCOES_SIM_NAO}
                                />
                            </FinField>
                            <FinField label="Somente se NÃO tiver aéreo?">
                                <ReactSelect
                                    value={{ value: dados.senaoaereo, label: dados.nomeSenaoaereo }}
                                    onChange={e => setDados({ ...dados, ...{ "senaoaereo": e.value, "nomeSenaoaereo": e.label } })}
                                    options={OPCOES_SIM_NAO}
                                />
                            </FinField>
                            <FinField label="Nome">
                                <FinInput
                                    id="nome"
                                    type="text"
                                    placeholder="Nome"
                                    value={dados.nome}
                                    onChange={e => setDados({ ...dados, ...{ "nome": e.target.value } })}
                                />
                            </FinField>
                            <FinField label="Grupo">
                                <ReactSelect
                                    isMulti={true}
                                    value={dados.grupo}
                                    onChange={(e) => {
                                        dados.grupo = dados.grupo || [];
                                        dados.grupo = e;
                                        setDados({ ...dados });
                                    }}
                                    options={OPCOES_GRUPO}
                                />
                            </FinField>
                            <FinField label="Cor">
                                <FinInput
                                    id="cor"
                                    type="text"
                                    placeholder="#345456"
                                    value={dados.cor}
                                    onChange={e => setDados({ ...dados, ...{ "cor": e.target.value } })}
                                />
                            </FinField>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 24 }}>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting}>
                            {isSubmitting
                                ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Salvando...</>
                                : <><FaSave size={16} /> Salvar</>
                            }
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
